import {
  RuleName
} from "../submit-form/const.js";

export const defaultOrderFormModelData = {
  isDeliveryRendered: false,
  isDeliveryShown: false,
  addressShipping: null,
  isSubmitting: false,
  isSubmit: false
};

export const FormProperty = {
  DELIVERY: `delivery`
};

export const DeliveryValue = {
  SELF_PICKUP: `1`,
  DELIVERY: `2`
};

export const ActionType = {
  BUILD_DELIVERY_ITEMS: `BUILD_DELIVERY_ITEMS`,
  HIDE_DELIVERY_ITEMS: `HIDE_DELIVERY_ITEMS`,
  SHOW_DELIVERY_ITEMS: `SHOW_DELIVERY_ITEMS`,
  SET_PLACEMARK: `SET_PLACEMARK`,
  FORM_SUBMIT_START: `FORM_SUBMIT_START`,
  FORM_SUBMIT_ERROR: `FORM_SUBMIT_ERROR`,
  FORM_SUBMIT_SUCCESS: `FORM_SUBMIT_SUCCESS`
};

export const MapParam = {
  ZOOM: 11,
  ICON: {
    URL: `/assets/templates/main/images/icons/pin-filled.svg`,
    SIZE: [80, 80],
    REAL_SIZE: [60, 80]
  }
};

export const PlacemarkOption = {
  draggable: true
};

export const DELIVERY_DATE_LIMIT_HOUR = 12;
export const DELIVERY_DATE_ITEMS_COUNT = 5;

export const CONNECTOR_URL = `/assets/components/ecommerce/connector.php`;

export const RequestAction = {
  SUBMIT_ORDER: `submit_order`
};

export const SubmitRule = {
  PHONE: {
    name: `phone`,
    rules: [
      RuleName.PHONE
    ]
  },
  EMAIL: {
    name: `email`,
    rules: [
      RuleName.EMAIL
    ]
  },
  PHONE_SHIPPING: {
    name: `phone_shipping`,
    rules: [
      RuleName.PHONE
    ]
  }
};

export const CATALOG_URL = `/catalog/`;
